'use client';

import { createContext, useContext } from "react";

export const AccountsContext = createContext(null);
export const useAccountsCtx = () => {
  const v = useContext(AccountsContext);
  if (!v) throw new Error("useAccountsCtx used outside <LightAccountsModule>.");
  return v;
};

export const defaultCopy = {
  page_title: "Corporate customers",
  page_subtitle: "The companies and customers you've won.",
  cta_add: "Add customer",
};

export const errText = (e) =>
  e?.response?.data?.detail || e?.message || "Something went wrong. Please try again.";

export const initialsOf = (name) =>
  (name || "?").trim().split(/\s+/).map((p) => p[0]).slice(0, 2).join("").toUpperCase();

export const formatMoney = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(v);
  if (isNaN(n)) return "";
  return "₹" + n.toLocaleString("en-IN");
};

export const formatPhone = (raw) => {
  const d = String(raw || "").replace(/\D/g, "");
  if (d.length !== 10) return raw || "";
  return `${d.slice(0, 5)} ${d.slice(5)}`;
};
